import Testimonials from "../../components/Testimonials/Testimonials";
import CounsellingAndPsychotherapy from "../../components/CounsellingAndPsychotherapy/CounsellingAndPsychotherapy";
import Header from "../../components/Header/Header";

const Home = () => {
  return (
    <>
      <Header />
      <CounsellingAndPsychotherapy />
      <Testimonials />
    </>
  );
};

export default Home;
